import { InputNumber as AntdInputNumber } from "antd"
const InputNumber = props => {
  return <AntdInputNumber controls={false} {...props}></AntdInputNumber>
}

export default InputNumber
